var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.prefixCls + '__btn']},[_c('t-button',{attrs:{"size":"sm"},nativeOn:{"click":function($event){return _vm.$_onPopperCancel($event)}}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),_c('t-button',{attrs:{"color":"primary","size":"sm"},nativeOn:{"click":function($event){return _vm.$_onPopperConfirm($event)}}},[_vm._v(_vm._s(_vm.confirmText))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3ece32","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/poptip/popper-button.vue
// module id = 632
// module chunks = 0 1 15